<template lang="html">
  <div>

    <div v-if="!wizardEnabled"> </div>
    
    <div id="wizardClaimLine" class="box wizardBox" v-if="wizardEnabled">
      <div class="grid has-1-cols">
        <div class="grid" v-if="hasSteps">
          <div class="cell">
            
            <div v-if="currentStep.id == 'claimLine_WizStep_Init'">
              <bulmaFieldSetInternalStore v-bind:id="currentStep.id" v-bind:record="stepRecord" v-bind:stepprops="currentStep"></bulmaFieldSetInternalStore>
            </div>
            
            <div v-if="currentStep.id == 'claimLineWizard_form_invoices'">
              <!-- <div class="spacer-small">
                <div class="tabs is-toggle is-toggle-rounded">
                  <ul>
                    <li v-bind:class="{'is-active': invoice_source_sf}" v-on:click="setTableSource('sf')"> <a> <span class="icon is-small"><i class="fas fa-file-alt"></i></span> <span> Recent </span> </a> </li>
                    <li v-bind:class="{'is-active': !invoice_source_sf}" v-on:click="setTableSource('file')"> <a> <span class="icon is-small"><i class="fas fa-file-alt"></i></span> <span> Historical </span> </a> </li>
                  </ul>
                </div>
              </div> -->
              <div>
                <div> <component v-if="invoice_source_sf" v-bind:is="'bulmaTableInternalStore'" v-bind:id="currentStep.id" @rowSelected="setTableSelection($event)"></component> </div>
                <div> 
                  <component v-if="!invoice_source_sf && fileRows && fileRows.length > 0" v-bind:is="'bulmaTableInternalStore'" v-bind:id="currentStep.id" v-bind:overrideSource="true" v-bind:overrideRows="fileRows" @rowSelected="setTableSelection($event)"></component>
                  <div class="has-text-centered" v-if="!invoice_source_sf && fileRows && fileRows.length <= 0"> NO RESULTS </div>
                </div>
              </div>
            </div>
            
            <div v-if="currentStep.id == 'claimLine_WizStep_Defects'">
              <div>
                <bulmaFieldSetInternalStore v-bind:id="currentStep.name" v-bind:record="stepRecord" v-bind:stepprops="currentStep" v-on:bubbleUpChange="fieldChange($event)"></bulmaFieldSetInternalStore>
              </div>
              <div class="spacer-small"></div>
              <div>
                <div class="box">
                  <div v-if="atLeastOneAttachment == false">
                    <p class="warning-msg has-text-centered mt-4 mb-5"> At least one attachment is required </p>
                  </div>
                  <bulmaPicturesManager v-bind:id="currentStep.name" @send-pictures="savePictures($event)"></bulmaPicturesManager>
                </div>
              </div>
              <div class="spacer-small"></div>
              <div>
                <div class="box">
                  <bulmaTableInternalStore v-bind:id="'claimLine_wizard_files'" v-bind:overrideRecord="getInternalRecord('recordClaimLine')" ></bulmaTableInternalStore>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      
      <div class="grid" v-if="hasSteps">
        <div class="cell has-text-centered" v-if="showNextStepBtn"> 
          <button v-for="nextStep in currentStep.nextStepsArray" v-bind:key="nextStep.name" v-bind:disabled="stepIncomplete" v-on:click="goToNextStep(currentStep, nextStep)" class="button is-link mr-4 ml-4" > {{ nextStep.stepLabel }} </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'wizardClaimLine',
  components: { },
  
  props: {
    config: Object,
  },
  
  data() {
    return {
      currentStep: { },
      recordMap: {},
      tableSource: 'sf',
      fileRows: undefined,
      stepIncomplete: false,
      atLeastOneAttachment: false
    }
  },
  
  computed: {
    hasSteps: function() {
      return this.config.steps.length > 0 && this.config.steps[this.config.store.initialStepPhaseNum] != undefined;
    },
    showNextStepBtn: function() {
      return this.currentStep.nextStepsArray != undefined && this.currentStep.nextStepsArray.length >= 0;
    },
    stepRecord: function() {
      let record = this.recordMap[this.currentStep.recordTarget]
      return record;
    },
    invoice_source_sf: function() {
      return this.tableSource == 'sf';
    },
    wizardEnabled: function() {
      let claim = this.config.store.recordClaim;
      return ((claim.Status__c && claim.Status__c.toLowerCase() == 'open') && (claim.Approval_status__c && claim.Approval_status__c.toLowerCase()  == 'created'));
    }
  },
  
  async created() { },
  
  mounted: function() {
    this.currentStep = (this.hasSteps) ? this.config.steps[this.config.store.initialStepPhaseNum] : { id: "not found", name: "" };
    
    this.config.store.recordClaim = this.$store.getters.getRecordData;
    
    for(let step of this.config.steps) {
      this.recordMap[step.recordTarget] = this.config.store[step.recordTarget];
    }
  },
  
  
  watch: {
    tableSource (newVal, oldVal) {
      console.log(`watch tableSource: ${oldVal} --> ${newVal}`);
      if(newVal == 'file') {
        this.queryFile().then((rows) => { this.fileRows = rows; });
      } else {
        this.fileRows = undefined;
      }
    }
  },
  
  methods: {     
    getInternalRecord: function(recordTargetName) {
      return this.recordMap[recordTargetName];
    },
    
    replaceInternalRecord: function(recordTargetName, replacement) {
      delete this.recordMap[recordTargetName];
      this.recordMap[recordTargetName] = replacement;
      return;
    },
    
    goToNextStep: async function(step, nextStep) {
      console.log('goToNextStep', step, nextStep);
      this.stepIncomplete = this.checkMissingReqFields(step);
      
      // if(this.stepIncomplete) {
      //   console.log('missingFields !!!! ');
      //   return;
      // }
      
      if(nextStep.actions && nextStep.actions.length > 0) {
        for(let action of nextStep.actions) {
          console.log('step action', action);
          let record = this.getInternalRecord(action.recordTarget);
          console.log('record action', JSON.stringify(record));

          if(action.name == 'attachmentRequired') {
            if(this.atLeastOneAttachment == false) {
              return;
            }
          }
          
          if(action.name == 'cloneFields') {
            let source = this.getInternalRecord(action.sourceTarget);
            for(let mapField of action.arrayMapFields) {
              record[mapField.dest] = source[mapField.source];
            }
          }
          
          if(action.name == 'upsertRecord') {
            if(record.Invoice_Line__c && record.Invoice_Line__c.startsWith('RID_')) {
              record.Invoice_Nr__c = record.Invoice_Line__c.replace('RID_', '');
              delete record.Invoice_Line__c;
            }
            
            let prop = await this.$store.dispatch('createProperties', { table: action.table, data: record });
            console.log('prop', prop);
            
            if(record.Id == undefined) {
              let actionResult = await this.$store.dispatch('create_record', { object: action.table, properties: prop, notUpdateRecord: true });
              if(actionResult.data && actionResult.data.success) {
                record.Id = actionResult.data.id;
              }
            } else {
              delete record.Claim__c;
              
              await this.$store.dispatch('update_record', { object: action.table, recordId: record.Id, properties: prop });
              this.atLeastOneAttachment = false;
            }
            
            this.internalRefresh(300);
          }
          
          if(action.name == 'clearRecord') {
            this.replaceInternalRecord(action.recordTarget, {});
            console.log('clearRecord', this.recordMap);
          }

          if(action.name == 'goToRecord') {
            console.log('goToRecord', record);
            let id = record[action.fieldName];
            let path = `/${action.newPath.process}/d/${id}`
            this.$router.push(path).catch((err) => {
              console.log(err);
              this.$router.go();
            })
          }
        }
      }
      
      let stepNum = step == 'init' ? this.config.store.initialStepPhaseNum : nextStep.stepPhaseNum;
      let stepObject = this.getStepObject(stepNum);

      if(stepObject) {
        this.config.store.currentStepPhaseNum = stepNum;
        this.currentStep = stepObject;
      }
    },

    getStepObject: function(stepNum) {
      let filteredArray = this.config.steps.filter(function(step) {
        return step.stepPhaseNum == stepNum;
      })

      return filteredArray.length > 0 ? filteredArray[0] : '';
    },
    
    checkMissingReqFields: function(step) {
      console.log('checkMissingReqFields');
      let rec = this.getInternalRecord(step.recordTarget);
      let arrayFields = step.recordFields;
      let missingFields = false;
      for(let field of arrayFields) {
        if(field.required) {
          if(rec[field.fieldname] == undefined || rec[field.fieldname] == '') {
            field.success = false;
            missingFields = true;
          }
        }
      }
      return missingFields;
    },
    
    fieldChange: function(event) {
      console.log('fieldChange', event);
      let rec = this.getInternalRecord(event.recordTarget);
      if(event.fields) {
        event.fields.forEach(function(value, key) {
          rec[key] = value;
        })
      }
      
      this.stepIncomplete = this.checkMissingReqFields(this.currentStep);
    },
    
    savePictures: async function(event) {
      console.log('savePictures')
      if(event && event.pictures) {
        let record = this.stepRecord;
        for(let fileData of event.pictures) {
          let fileName = record.Id + '_' + new Date().getTime();
          let extension = '';
          if(fileData.startsWith('data:')) {
            let splitted = fileData.split(';');
            let fileType = splitted[0].replace('data:', '').replaceAll('/','.');
            extension = '.' + fileType;
            fileData = splitted[1].replace('base64,','');
          }
          
          let resp = await this.$store.dispatch('create_content_version', {
            filename: fileName,
            path: fileName + extension,
            data: fileData,
            parentId: record.Id
          });
          console.log(resp);
          
          this.atLeastOneAttachment = true;
          
          this.internalRefresh();
        }
      }
      
      this.stepIncomplete = this.checkMissingReqFields(this.currentStep);
    },
    
    setTableSelection: function(event) {
      console.log('setTableSelection')
      console.log(event, event.row);
      if(event && event.row) {
        let rec = this.getInternalRecord(this.currentStep.recordTarget);
        if(event.row.Id) rec.Invoice_Line__c = event.row.Id;
        if(event.row.SF_Sold__c) rec.Quantity_Supplied__c = event.row.SF_Sold__c;
        if(event.row.Sales__c) rec.Invoice_Sales__c = event.row.Sales__c;
      }
      
      this.stepIncomplete = this.checkMissingReqFields(this.currentStep);
    },
    
    internalRefresh: function(millisDelay=100) {
      this.$store.commit('BROADCAST_MESSAGE', { message: 'refresh' });
      setTimeout(() => {
        this.$store.commit('CLEAR_BROADCAST', { message: 'refresh' });
      }, millisDelay);
    },
    
    setTableSource: function(sourceName) {
      this.tableSource = sourceName;
    },
    
    queryFile: async function() {
      let rec_claim = this.getInternalRecord('recordClaim');
      let rows = [];
      let response = await this.$store.dispatch('queryInvoiceFile', { recordid: rec_claim.Account__c, year: '2024' });
      console.log('response', response);
      
      if(response && response.data && response.data.length > 0) {
        let mapProducts = new Map();
        let mapSalesPerson = new Map();
        for(let row of response.data) {
          if(row["Material"]) mapProducts.set(row["Material"], undefined);
          if(row["Role Sales Person - Key"]) mapSalesPerson.set(row["Role Sales Person - Key"], undefined);
        }
        
        
        if(mapProducts.size > 0) {
          let stringCodes = '';
          for(let [key] of mapProducts.entries()) {
            stringCodes += (stringCodes.length > 0) ? `, '${key}'` : `'${key}'`;
          }
          console.log('prod stringCodes', stringCodes)
          
          let res = await this.$store.dispatch('search_records', { id: 'claimLine_WizStep_Defects', object: 'Product2', filters: [{"fieldname": "SAP_Code__c", "operator": "IN", "value": stringCodes }], properties: ['Id', 'ProductCode', 'Name', 'Collection_Text__c', 'Shape__c', 'SAP_Code__c'], limit: 1000 });
          if(res.data && res.data.records && res.data.records.length > 0) {
            for(let record of res.data.records) {
              mapProducts.set(record.SAP_Code__c, record);
            }
          }
        }
        
        if(mapSalesPerson.size > 0) {
          let stringCodes = '';
          for(let [key] of mapSalesPerson.entries()) {
            stringCodes += (stringCodes.length > 0) ? `, '${key}'` : `'${key}'`;
          }
          let res = await this.$store.dispatch('search_records', { id: 'claimLine_WizStep_Defects', object: 'Contact', filters: [{"fieldname": "SAP_Role_Code__c", "operator": "IN", "value": stringCodes }], properties: ['Id', 'Name'], limit: 1000 });
          if(res.data && res.data.records && res.data.records.length > 0) {
            for(let record of res.data.records) {
              mapSalesPerson.set(record.SAP_Role_Code__c, record);
            }
          }
        }
        
        let fieldMapping = this.getFileFieldMapping();          
        console.log('fieldMapping', fieldMapping)
        for(let row of response.data) {
          let record = { Account__c: rec_claim.Account__c, show: true };
          record = this.populateRecord(row, record, fieldMapping, '^|^');
          
          if(record.Id == undefined) {
            record.Id = 'RID_' + record.Invoice_Key__c;
          }
          
          if(row["Material"] && mapProducts.has(row["Material"])) {
            let product = mapProducts.get(row["Material"]);
            if(product) {
              record.Product__c = product.Id;
              record.Product__r = product; 
            }
          }
          
          if(row["Role Sales Person - Key"] && mapSalesPerson.has(row["Role Sales Person - Key"])) {
            let salesPerson = mapSalesPerson.get(row["Role Sales Person - Key"]);
            if(salesPerson) {
              record.SalesPerson__c = salesPerson.Id;
              record.SalesPerson__r = salesPerson; 
            }
          }
          
          rows.push(record);
        }
      } else {
        console.log('no records found.');
      }
      
      return rows;
    },
    
    populateRecord: function(source, target, fieldMapping, sourceFieldseparator) {
      for(let targetFieldName of Object.keys(fieldMapping)) {
        let sourceFieldName = fieldMapping[targetFieldName];
        if(sourceFieldName.includes(sourceFieldseparator)) {
          let arrayFields = sourceFieldName.split(sourceFieldseparator);
          for(let field of arrayFields) {
            target[targetFieldName] = (target[targetFieldName]) ? target[targetFieldName] + ' ' + source[field] : source[field];
          }
        } else {
          target[targetFieldName] = source[sourceFieldName];
        }
      }
      
      return target;
    },
    
    
    getFileFieldMapping: function() {
      let fieldMapping = {
        "Order_Date__c": "Order Date",
        "Billing_Date__c": "Billing Date",
        "PC_Sold__c": "PC Sold YTD",
        "SF_Sold__c": "SF Sold YTD",
        "Sales__c": "Sales YTD",
        "Cost__c": "Cost YTD",
        "Margin__c": "Margin YTD",
        "Invoice_Key__c": "Invoice Number^|^Billing Item"
      }
      
      return fieldMapping;
    }
    
  }
  
  
  // {
  //   "Sales Org":"CC51"
  // "Distribution Channel - Key":"51"
  // "Role Sales Person - Key":"CINH_51"
  // "Sales Person":"IN-HOUSE ACCOUNTS LAK"
  // "Sold-to party - Key":"10010447"
  // "Customer":"JOSEPH EUBANKS LLC"
  // "Invoice Number":"1505172223"
  // "Billing Item":"100"
  // "Material":"COLA65306217"
  // "Pricing Type":"Template"
  // "Grade+":"First"
  // }
  
  // {
  //   "Order Date": "Order_Date__c",
  //   "Billing Date": "Billing_Date__c",
  //   "Material": Product__r.ProductCode,
  //   "PC Sold YTD": "PC_Sold__c",
  //   "SF Sold YTD": "SF_Sold__c",
  //   "Sales YTD": "Sales__c",
  //   "Cost YTD": "Cost__c",
  //   "Margin YTD": "Margin__c"
  //   "????" : "Invoice_Key__c"
  // }
  
  // devo recuperare le info del prodotto
  // devo recuperare le info del salesperson.  contact.SAP_Role_Code__c
  // devo costruire la key con i valori dell'ordine? "1590609585-100" - Sales document + Sales document item OPPURE Invoice Number + Billing Item
  
  // Product__c:"01tKd000002HhDZIA0"
  // Product__r:Object
  // Account__r:Object
  // SalesPerson__r:Object
  
  
  
}
</script>

<style scoped>

.spacer-small {
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  white-space: break-spaces;
}

.wizardBox {
  border: 0.3rem solid grey;
  margin: 2.5rem 1rem;
}

.warning-msg {
  color: orange;
}


@media screen and (max-width: 540px) {
  .wizardBox {
    border: 0.3rem solid grey;
    margin: 1.5rem 0rem;
  }
}

</style>
/*
app.post('/getContentBody', async function (req, res) {
  console.log("Starting the content body retrieval process");
  const receivedData = jwt.verify( req.body.payload, auth.clientHash);
  const receivedURI = receivedData.uri;
  
  try {
    sfdc.getContentBody(receivedURI).then((result) => {
      if ("name" in result && result.code=="Error") {
        res.status(500).json({"body": result});
      }else{
        res.status(200).json({"body": result.toString('base64')});
      }
    })
  } catch (error) {
    console.error('Error during content body request:', error);
    res.status(500).json({ error: 'Error during content body request' });
  }
  
});

*/